import { lazyArea } from "@baton/i18n";

/**
 * 001 FR-153's English catalogue (2026-09-28): the banner an unverified person sees across the top of
 * a Team, and the send on the profile and on the welcome screen, each given the area through this
 * value (`packages/i18n/src/catalogue.ts`) so its strings stay out of the application's first load.
 * The verification link's page moved to the public entry on 2026-09-29, and the words it shares with
 * these are in `base.json`, which every entry carries.
 */
export const VERIFY_AREA = lazyArea("verify", () => import("@baton/i18n/catalogues/en/verify.json").then((module) => module.default));
